module.exports = __webpack_public_path__ + "img/ic-dropdown-eba.6f814675.svg";